<div class="viewjob-hero">
  <!-- Decorative orbs and wave to match the Apple-like hero -->
  <svg class="hero-orb orb-a" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="appliedOrbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6"/>
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#appliedOrbGradientA)"/>
  </svg>
  <svg class="hero-orb orb-b" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="appliedOrbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35"/>
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#appliedOrbGradientB)"/>
  </svg>
  <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
    <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#f6f6f6"></path>
  </svg>
</div>
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text"></div>
  </div>
</div>
<div class="view-job">
  <div class="job-container">
    <div class="vacancies">
      <div #vacancyRef class="vacancy">
        <div class="applied">
          <div class="applied-header">Sollicitatie ontvangen!</div>
          <div class="applied-paragraph">
            Hartelijk dank voor het indienen van je sollicitatie. We hebben je
            sollicitatie ontvangen en zullen binnenkort contact met je opnemen.
          </div>
          <div class="applied-paragraph last">Ontdek meer en volg ons op <span class="link-container"><icon name="linkedin"></icon><a class="link" href="https://www.linkedin.com/company/blauwtand/">LinkedIn</a></span>!</div>
          <div>
            <button class="apple-cta apple-cta--blue" (click)="navigateTo('home')">
              <span>We gaan vanzelf terug in&nbsp;<span class="countdown">{{ countdown }}</span>s</span>
              <icon name="navigate_next"></icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
